import { Injectable } from '@angular/core';
import { NavigationStart } from '@angular/router';
import { AuthService } from '@core/auth.service';
import { fromEvent, Subject, takeUntil } from 'rxjs';
import { CommonVariable } from 'src/app/app.constants';

@Injectable({
  providedIn: 'root'
})
export class AppRouteService {
  private unsubscribe$ = new Subject<void>();

  constructor(
    private authService: AuthService,
  ) { }

  popStateEvent() {
    fromEvent(window, "popstate")
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(() => {
        if (this.specificRouteCondition()) {
          history.pushState(null, "", location.href);
        }
      });
  }

  updateBasedOnEvent(event: NavigationStart) {
    if (this.specificRouteCondition() && event.navigationTrigger == "popstate") {
      history.pushState(null, "", location.href);
      this.authService?.disableNavigation$.next(true);
    } else {
      this.authService?.disableNavigation$.next(false);
    }
  }

  private specificRouteCondition(): boolean {
    const currentLocation = location.href;
    const flag = CommonVariable?.routesToPreventPopState?.find((route) => currentLocation.includes(route));
    return !!flag;
  }
  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
